import { z } from 'zod';

export const activitySubjectTypeSchema = z.enum([
  'budget',
  'budget_period',
  'payment_card',
  'transaction',
  'expense_split',
  'group',
  'group_member',
  'debt',
  'goal',
  'tag',
  'user',
  'template_report',
  'site_setting',
  'exchange_rate',
]);
export type ActivitySubjectType = z.infer<typeof activitySubjectTypeSchema>;

export const activityActionSchema = z.enum([
  'created',
  'updated',
  'deleted',
  'restored',
  'confirmed',
  'cancelled',
  'refunded',
  'paid',
  'invited',
  'joined',
  'left',
  'dismissed',
  'unpublished',
  'admin.user.makeAdmin',
  'admin.user.revokeAdmin',
  'admin.user.softDelete',
  'admin.user.restore',
  'admin.user.update',
  'admin.user.create',
  'admin.user.resetPassword',
  'admin.user.resendVerification',
  'admin.user.impersonate',
  'admin.user.gdprExport',
  'admin.subscription.assign',
  'admin.subscription.cancel',
  'admin.subscription.extendTrial',
  'admin.subscription.changePlan',
  'admin.plan.create',
  'admin.plan.update',
  'admin.plan.archive',
  'admin.plan.restore',
  'admin.coupon.create',
  'admin.coupon.delete',
  'admin.refund.create',
  'admin.siteSetting.upsert',
  'admin.siteSetting.remove',
  'admin.exchangeRate.upsert',
  'admin.exchangeRate.sync',
]);
export type ActivityAction = z.infer<typeof activityActionSchema>;

export const listActivityLogsQuerySchema = z.object({
  subjectType: activitySubjectTypeSchema.optional(),
  subjectId: z.string().uuid().optional(),
  causerId: z.string().uuid().optional(),
  action: activityActionSchema.optional(),
  dateFrom: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  dateTo: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  page: z.coerce.number().int().positive().default(1),
  perPage: z.coerce.number().int().min(1).max(100).default(20),
});
export type ListActivityLogsQuery = z.infer<typeof listActivityLogsQuerySchema>;
